export default "__VITE_ASSET__1d2eea23__"